import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {_} from 'utils/i18n';

import {LessonShape} from '../../lessons/shapes';

import LessonForm from '../../lessons/components/LessonForm';
import LessonComplete from '../../lessons/components/LessonComplete';
import NotFound from '../../../components/NotFound';

const MessageLabel = _('Thank you! This questionnaire is now complete.');
const DoesNotExistLabel = _('This questionnaire does not exist or has been removed.');

const QuestionnaireComplete = () => (
    <LessonComplete message={MessageLabel} />
);

const mapStateToProps = ({CSRFMiddlewareToken, questionnaire}, {id}) => ({
    questionnaire: questionnaire[id],
    LessonComplete: QuestionnaireComplete,
    CSRFMiddlewareToken,
});

/**
 * Renders a Lesson form for performing a questionnaire
 */
const Questionnaire = ({questionnaire, CSRFMiddlewareToken}) => (
    questionnaire ? (
        <LessonForm {...questionnaire} CSRFMiddlewareToken={CSRFMiddlewareToken} />
    ) : <NotFound>{DoesNotExistLabel}</NotFound>
);

Questionnaire.propTypes = {
    questionnaire: PropTypes.shape(LessonShape),
    CSRFMiddlewareToken: PropTypes.string.isRequired,
};

Questionnaire.defaultProps = {
    questionnaire: null,
};

export default connect(mapStateToProps)(Questionnaire);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/Questionnaire.js